import React from 'react';

function FoodCourtHotspot(props) {
  const { onClick, style, className } = props;
  return (
    <div onClick={onClick} style={{cursor:'pointer', ...style}} className={className}>
      <img src={require('./FoodCourtHotspot.svg').default} alt="" style={{width:'100%',height:'auto'}} />
    </div>
  );
}

export default FoodCourtHotspot;
